<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">Usuario</h5>
                <div class="form-desc">Editar Usuario</div>
                <div class="row">
                  <div class="col-sm-3 col-md-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.username && current.errors.username.length > 0 }"
                      >Nombre de Usuario</label>
                      <input
                        v-model="current.username"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="Usuario"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.username && current.errors.username.length > 0 }"
                      >
                      <small
                        v-if="current.errors && current.errors.username"
                        class="form-text text-danger"
                      >{{ current.errors.username[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.first_name && current.errors.first_name.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.first_name"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.first_name && current.errors.first_name.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.first_name"
                        class="form-text text-danger"
                      >{{ current.errors.first_name[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.last_name && current.errors.last_name.length > 0 }"
                      >Apellído</label>
                      <input
                        v-model="current.last_name"
                        class="form-control"
                        placeholder="Apellido"
                        autofocus="autofocus"
                        v-bind:class="{ 'is-invalid': current.errors.last_name && current.errors.last_name.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.last_name"
                        class="form-text text-danger"
                      >{{ current.errors.last_name[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-8">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.email && current.errors.email.length > 0 }"
                      >Email</label>
                      <input
                        v-model="current.email"
                        class="form-control"
                        placeholder="Email"
                        v-bind:class="{ 'is-invalid': current.errors.email && current.errors.email.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.email"
                        class="form-text text-danger"
                      >{{ current.errors.email[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          name="optionsRadios"
                          v-model="current.is_active"
                          type="radio"
                          value="true"
                        />Activa
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.is_active"
                          name="optionsRadios"
                          type="radio"
                          value="false"
                        />Inactiva
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link class="btn btn-default" :to="{ name: 'usuarios', params: {  }}">
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import UsuariosService from "@/services/accounts/UsuariosService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      current: {
        errors: {}
      }
    };
  },

  computed: {},
  mounted() {
    if (this.$route.params.id) {
      UsuariosService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
      });
    }
  },

  methods: {
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      UsuariosService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Usuario",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "usuarios",
            params: { id: self.current.id }
          });
        })
        .catch(error => {
            Vue.nextTick(function() {
              self.current.errors = Object.assign({}, error.response.data);
              console.log(self.current.errors);
            });
        });
    },
    showModal(e) {
      e.preventDefault();
    }
  }
};
</script>
